module.exports = __webpack_public_path__ + "img/leaf_1.3b46a5e6.png";